import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'page-error',
	styleUrls: ['error.component.scss'],
	templateUrl: 'error.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {}
